var path = 'app/components/common/loading/loading.html';
var html = "<div class=\"row\" ng-if=\"vm.isLoading\"><div class=\"col-lg-12 text-center\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"col-lg-12 text-center\"><span>{{vm.message}}</span></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/loading/loading.html
// module id = 506
// module chunks = 0